import React, { Component } from 'react';
import classNames from 'classnames';
import styles from '@src/slide/application/service/snap-line-service/render/components/extend-line/dot-line.less';
import { Orient } from '@src/slide/application/service/snap-line-service/interface/orient.interface';
import type { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';
import { IBaseUIProps } from '@src/slide/application/service/snap-line-service/interface/render.interface';

interface DotLineProps extends Omit<IBaseUIProps, 'strokeWidth'> {
    rect: IRect;
    orient: Orient;
    color?: string;
    classnames?: Record<string, boolean>;
}

export class DotLine extends Component<DotLineProps> {
    public static defaultProps = {
        color: '#d08a7c',
    };

    public render() {
        const { top, left, height, width } = this.props.rect;
        const { scale, strokeDash: originStrokeDash  } = this.props;
        const style = {
            top,
            left,
            width,
            height,
        };

        const displayStyle = {
            top: style.top * scale.frameScale,
            left: style.left * scale.frameScale,
            width: style.width,
            height: style.height,
        };

        const strokeWidth = (this.props.orient === Orient.HORIZONTAL ? height : width) / scale.graphicScale;
        if (this.props.orient === Orient.HORIZONTAL) {
            style.top -= strokeWidth / 2;
            displayStyle.width *= scale.frameScale;
            displayStyle.height /= scale.graphicScale;
        } else {
            style.left -= strokeWidth / 2;
            displayStyle.height *= scale.frameScale;
            displayStyle.width /= scale.graphicScale;
        }

        const svgLinePosition = this.props.orient === Orient.HORIZONTAL ? {
            x1: 0,
            y1: (strokeWidth / 2),
            x2: '100%',
            y2: (strokeWidth / 2),
        } : {
            x1: (strokeWidth / 2),
            y1: 0,
            x2: (strokeWidth / 2),
            y2: '100%',
        };

        const strokeDash = originStrokeDash / scale.graphicScale;

        return <svg style={displayStyle} className={classNames({
            [styles['snap-line-dot-line']]: true,
            ...this.props.classnames,
        })}>
            <line
                x1={svgLinePosition.x1}
                y1={svgLinePosition.y1}
                x2={svgLinePosition.x2}
                y2={svgLinePosition.y2}
                stroke={this.props.color}
                // strokeWidth在缩放的情况下不变
                strokeWidth={strokeWidth}
                strokeDasharray={`${strokeDash}, ${strokeDash}`}
            />
        </svg>;
    }
}
